module.exports = __webpack_public_path__ + "img/2_27.ca78f096.png";